<template>
  <!-- Footer -->
  <footer class="sticky-footer bg-white">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Developed by DijitalCODE</span>
      </div>
    </div>
  </footer>
  <!-- End of Footer -->
</template>

<script>
export default {
  name: "Footer",
};
</script>
